module.exports = __webpack_public_path__ + "img/spribe.80d75ade.jpg";